module.exports = __webpack_public_path__ + "static/media/102.da956872.png";